<template>
    <div>
        <header>
            <p>主体信息列表</p>
        </header>
        <div class="container">
            <div class="header-search">
                <p>
                    <span>主体名称/主体代码 : </span>
                    <el-input v-model="nameValue" placeholder="请输入" size="small" style="width: 240px" clearable></el-input>
                </p>
                <p style="margin-left: 20px">
                    <span>入库时间 : </span>
                    <el-date-picker
                            size="small"
                            style="width: 240px"
                            v-model="timeValue"
                            type="daterange"
                            value-format="yyyy-MM-dd"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">
                    </el-date-picker>
                </p>
                <p style="margin-left: 20px">
                    <span>状态 : </span>
                    <el-select v-model="selectValue" placeholder="请选择" size="small" clearable>
                        <el-option label="待提交" value="-1"></el-option>
                        <el-option label="待审核" value="0"></el-option>
                        <el-option label="正常" value="1"></el-option>
                        <el-option label="暂停" value="2"></el-option>
                        <el-option label="部分暂停" value="3"></el-option>
                    </el-select>
                    <el-button size="small" style="margin-left: 10px" @click="searchList">搜索</el-button>
                    <el-button size="small" @click="searchList">刷新</el-button>
                </p>
            </div>
        </div>
        <main>
            <div class="main-table">
                <el-table
                        border
                        :data="tableList"
                        :header-cell-style="{
                            'background-color': '#EFF3F6',
                            'font-size': '14px',
                            'color': '#000000',
                        }">
                    <el-table-column
                            fixed
                            prop="date"
                            type="index"
                            label="序号"
                            align="center"
                            width="60px">
                        <template scope="scope">
                            <span>{{(currentPage - 1) * pageSize + scope.$index + 1}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                            label="操作"
                            width="100"
                            align="center">
                        <template scope="scope">
                            <el-button type="text" @click="goDetail(scope.row)">查看</el-button>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="status"
                            label="状态"
                            width="120"
                            align="center">
                        <template scope="scope">
                            <p v-if="scope.row.state == -1" class="change-examine"><i class="examine-ing-adopt"></i><span>待提交</span></p>
                            <p v-if="scope.row.state == 0" class="change-examine"><i class="examine-ing-adopt"></i><span>待审核</span></p>
                            <p v-if="scope.row.state == 1" class="change-examine"><i class="examine-adopt"></i><span>正常</span></p>
                            <p v-if="scope.row.state == 2" class="change-examine"><i class="examine-no-adopt"></i><span>暂停</span></p>
                            <p v-if="scope.row.state == 3" class="change-examine"><i class="examine-no-adopt"></i><span>部分暂停</span></p>
                            <p v-if="scope.row.state == 4" class="change-examine"><i class="examine-no-adopt"></i><span>核验不通过</span></p>
                            <p v-if="scope.row.state == 5" class="change-examine"><i class="examine-adopt"></i><span>正常</span></p>
                            <p v-if="scope.row.state == 6" class="change-examine"><i class="examine-adopt"></i><span>正常</span></p>
                            <p v-if="scope.row.state == 7" class="change-examine"><i class="examine-adopt"></i><span>正常</span></p>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="entType"
                            label="主体大类"
                            width="100"
                            align="center">
                        <template scope="scope">
                            <p v-if="scope.row.entType == 1">自然人</p>
                            <p v-if="scope.row.entType == 2">法人</p>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="name"
                            align="center"
                            width="202"
                            label="主体名称">
                    </el-table-column>
                    <el-table-column
                            prop="uniqueCode"
                            label="主体代码"
                            width="190"
                            align="center">
                    </el-table-column>
                    <el-table-column
                            prop="roleNames"
                            align="center"
                            width="250"
                            label="交易主体类型">
                    </el-table-column>
                    <el-table-column
                            prop="successTime"
                            label="入库时间"
                            width="174"
                            align="center">
                    </el-table-column>
                    <el-table-column
                            prop="updateUser"
                            label="修改人"
                            width="190"
                            align="center">
                    </el-table-column>
                    <el-table-column
                            prop="updateTime"
                            label="修改时间"
                            width="174"
                            align="center">
                    </el-table-column>
                </el-table>
                <el-pagination
                        style="padding-bottom: 20px"
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="currentPage"
                        :page-size="pageSize"
                        layout="total, prev, pager, next"
                        :total="total">
                </el-pagination>
            </div>
        </main>
    </div>
</template>

<script>
    import {mapState} from "vuex";
    export default {
        name: "index",
        data() {
            return {
                currentPage:1,
                pageSize:10,
                total:0,
                nameValue:'',
                timeValue:'',
                pickerValue: '',
                selectValue:'',
                tableList: []
            }
        },
        computed:{
            ...mapState({
                id:(state) => state.user.orgId,
                entId:(state) => state.user.userinfo.userId
            })
        },
        created() {
            this.querData();
        },
        methods: {
            // 搜索
            searchList(){
                this.currentPage = 1;
                this.querData();
            },
            // 获取数据
            querData() {
                if(this.id){
                    this.newId =this.id
                }else{
                    this.newId =this.entId
                }
                this.$http.post('/entinfo/base/combine', {
                    page: this.currentPage,
                    rows: this.pageSize,
                    filter: {
                      id:this.newId,
                      state: this.selectValue ? Number(this.selectValue) : null,
                      startTime: this.timeValue ? this.timeValue[0] : null,
                      endTime: this.timeValue ? this.timeValue[1] : null,
                    },
                    searchKey: this.nameValue ? this.nameValue :null,
                    orderBy: 'create_time desc'
                }).then((res) => {
                    if(res.data){
                        this.tableList = res.data.rows;
                        this.total = res.data.total;
                    }
                })
            },
            handleClick(row) {

            },
            selectMonitor(value){

            },
            dateMonitor(value){

            },
            handleSizeChange(val) {
                this.pageSize = val;
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.querData();
            },
            // 跳转到详情只读页
            goDetail(row){
                if(row.entType == 2){
                    // 法人详页
                    this.$router.push({path:'/mainDealManagementDetail/index',query:{id:row.id}})
                }else if(row.entType == 1){
                    // 自然人详页
                    this.$router.push({path:'/naturalBasicInformationChange/natural-basicInfo-view',query:{id:row.id}})
                }
            }
        },
    }
</script>

<style lang="scss" scoped>
    header{
        height: 68px;
        background: #fff;
        box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.1);
        display: flex;
        justify-content: space-between;
        align-items: center;
        p{
            font-size: 18px;
            font-weight: bold;
            color: #000000;
            margin-left: 32px;
        }
        button{
            width: 80px;
            height: 40px;
            background: #FFFFFF;
            border-radius: 2px;
            border: 1px solid rgba(0, 0, 0, 0.16);
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(0, 0, 0, 0.65);
            line-height: 40px;
            text-align: center;
            cursor: pointer;
            margin-right: 24px;
        }
    }
    .container{
        height: 80px;
        background: #fff;
        margin: 24px;
        border-radius: 2px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        .header-search {
            width: 100%;
            height: 80px;
            background: #fff;
            margin-bottom: 20px;
            line-height: 80px;
            padding: 0 20px;
            display: flex;
            /deep/ .el-input--suffix{
                height: 55px;
            }
        }
    }
    main{
        background: #FFFFFF;
        border-radius: 2px;
        margin: 24px;
        .main-table{
            margin: 0 32px;
            padding-top: 24px;
            .change-examine{
                display: flex;
                align-items: center;
                justify-content: center;
                i{
                    width: 6px;
                    height: 6px;
                    border-radius: 50%;
                    margin: 0 8px;
                }
                i.examine-adopt{
                    background: #52C41A;
                }
                i.examine-no-adopt{
                    background: #FA6400;
                }
                i.examine-ing-adopt{
                    background: orange;
                }
                span{
                    text-align: left;
                }
            }
        }
    }
</style>